import ApplicablePaymentItem from '../Domain/ApplicablePaymentItem';
import PrePaymentPaymentItem from '../Domain/PrePaymentPaymentItem';
import TpClientPaymentItem from '../Domain/TpClientPaymentItem';
import TpPrePaymentPaymentItem from '../Domain/TpPrePaymentPaymentItem';
import dateTimeHelper from '../Helpers/datetimeHelper';
import AuthService from './authService';
import SearchParams from '../Elements/SearchParams';
import TpClientPaymentsSearchParams from '../Contents/ThirdParty/TpClientPayment/TpClientPaymentsSearchParams';

export default class TpClientPaymentService {
  static GetPaymentsBySearching(orderById, orderDir, pageNumber, numberOfElements, searchItem, clearCache = false) {
    searchItem.EntryAfter = dateTimeHelper.toYYYYsMMsDD(searchItem.EntryAfter);
    searchItem.EntryBefore = dateTimeHelper.toYYYYsMMsDD(searchItem.EntryBefore);
    searchItem.PaymentInstrumentAfter = dateTimeHelper.toYYYYsMMsDD(searchItem.PaymentInstrumentAfter);
    searchItem.PaymentInstrumentBefore = dateTimeHelper.toYYYYsMMsDD(searchItem.PaymentInstrumentBefore);
    const searchParams = new SearchParams(
      searchItem,
      TpClientPaymentsSearchParams,
      orderById,
      orderDir,
      pageNumber,
      numberOfElements
    );

    const url = `/api/TpClientPayment/GetTpClientPaymentListAsync/?searchParams=${searchParams.serializeForBackendCall()}&clearCache=${clearCache}`;
    return AuthService.getInstance().CallBackendFunction(url);
  }

  static ConvertPaymentDBItems(itemlist) {
    return itemlist !== null ? itemlist.map((item) => new TpClientPaymentItem(item)) : [];
  }

  static ConvertApplicablePaymentDBItems(itemlist) {
    return itemlist !== null ? itemlist.map((item) => new ApplicablePaymentItem(item)) : [];
  }

  static GetTpRelatedPrePaymentsBySearching(
    orderById,
    orderDir,
    pageNumber,
    numberOfElements,
    searchItem,
    clearCache = false
  ) {
    const searchParams = {
      Command: '',
      OrderBy: orderById,
      OrderDirection: orderDir,
      PageNumber: pageNumber,
      NumberOfElementsOnAPage: numberOfElements,
      SearchItem: searchItem,
    };

    const url = `/api/TpClientPayment/GetTpRelatedPrepaymentClientPaymentListAsync/?searchParams=${JSON.stringify(
      searchParams
    )}&clearCache=${clearCache}`;
    return AuthService.getInstance().CallBackendFunction(url);
  }

  static GetTpPrePaymentsBySearching(
    orderById,
    orderDir,
    pageNumber,
    numberOfElements,
    searchItem,
    clearCache = false
  ) {
    const searchParams = {
      Command: '',
      OrderBy: orderById,
      OrderDirection: orderDir,
      PageNumber: pageNumber,
      NumberOfElementsOnAPage: numberOfElements,
      SearchItem: searchItem,
    };

    const url = `/api/TpClientPayment/GetTpPrepaymentClientPaymentListAsync/?searchParams=${JSON.stringify(
      searchParams
    )}&clearCache=${clearCache}`;
    return AuthService.getInstance().CallBackendFunction(url);
  }

  static ConvertPrePaymentPaymentDBItems(itemlist) {
    return itemlist !== null ? itemlist.map((item) => new PrePaymentPaymentItem(item)) : [];
  }

  static ConvertTpPrePaymentPaymentDBItems(itemlist) {
    return itemlist !== null ? itemlist.map((item) => new TpPrePaymentPaymentItem(item)) : [];
  }

  static GetByPaymentById(id) {
    return AuthService.getInstance().CallBackendFunction(`/api/TpClientPayment/GetPaymentByIdAsync/${id ? id : 0}`);
  }

  static ApplyPayment(applyItem) {
    return AuthService.getInstance().CallBackendFunctionPut(
      '/api/TpClientPayment/ApplyPaymentAsync',
      JSON.stringify(applyItem)
    );
  }

  static ApplyPaymentToOldInvoice(applyItem) {
    return AuthService.getInstance().CallBackendFunctionPut(
      '/api/TpClientPayment/ApplyPaymentToOldInvoiceAsync',
      JSON.stringify(applyItem)
    );
  }

  static RemovePayment(removeItem) {
    return AuthService.getInstance().CallBackendFunctionPut(
      '/api/TpClientPayment/RemovePaymentAsync',
      JSON.stringify(removeItem)
    );
  }

  static RemovePaymentFromOldInvoice(removeItem) {
    return AuthService.getInstance().CallBackendFunctionPut(
      '/api/TpClientPayment/RemovePaymentFromOldInvoiceAsync',
      JSON.stringify(removeItem)
    );
  }

  static CreateClientPayment(createItem) {
    if (createItem.CpDocdate) createItem.CpDocdate = dateTimeHelper.toYYYYsMMsDD(createItem.CpDocdate);
    const clientPaymentJson = JSON.stringify(createItem);

    return AuthService.getInstance().CallBackendFunctionPost(
      '/api/TpClientPayment/CreatePaymentAsync/',
      clientPaymentJson
    );
  }

  static CreateClientPaymentRefund(createItem) {
    createItem.RefundedOn = dateTimeHelper.toYYYYsMMsDD(createItem.RefundedOn);
    const paymentRefundJson = JSON.stringify(createItem);

    return AuthService.getInstance().CallBackendFunctionPut(
      '/api/TpClientPayment/CreatePaymentRefundAsync/',
      paymentRefundJson
    );
  }

  static ReversePayment(selectedId, comment) {
    const item = {
      TpClientPaymentId: selectedId,
      Comment: comment,
    };
    return AuthService.getInstance().CallBackendFunctionPut(
      `/api/TpClientPayment/ReversePaymentAsync/`,
      JSON.stringify(item)
    );
  }
}
